/* global module:false */
"use strict";

var $ = window.$;
var common = require('./common');
// bootstrap
//require('../../bower_components/bootstrap-sass/assets/javascripts/bootstrap');

var TPBS_header = (function(){

    var _maxHeightNav = 500;
    var _currentScrollTop = 0;
    var _minDiff = 100;
    var _maxDirQueueLength = 10;
    var _dirQueue = [];


    /**
     * _maxHeightNav getter
     */
    var getNavMaxHeight = function(){
        return _maxHeightNav;
    };

    /**
     * _maxDirQueueLength getter
     */
    var getMaxDirQueueLength = function(){
        return _maxDirQueueLength;
    };

    /**
     * Adjust navbar max height when open main nav
     */
    var adjustNavBarMaxHeight = function(windowHeight, headerHeight){
        var maxHeightNav = getNavMaxHeight();
        var newMaxHeight = maxHeightNav;

        // check whether windowHeight < _maxHeightNav or not
        if(windowHeight <= maxHeightNav){
            // adjust max-height to new value
            newMaxHeight = windowHeight - headerHeight;
            $('#navbar').addClass('fixed');
        }else{
            $('#navbar').removeClass('fixed');
        }

        // set max height
        $('#navbar').css('max-height', newMaxHeight);
    };

    /**
     * Nav click Event handler
     */
    var adjustNavBarMaxHeightHandler = function(){
        if($(window).width() < 768){
            // get window height
            var wh = common.getWindowHeight();
            // get top nav height
            var th = common.getTopNavHeight();
            // adjust nav
            adjustNavBarMaxHeight(wh, th);
        }
    };

    /**
     * Adjust main-navbar max height when open main nav
     */
    var adjustMainNavBarMaxHeight = function(windowHeight, headerHeight){
        var diff = windowHeight - headerHeight;
        // set max height
        $('#main-navbar').css('max-height', diff);
    };

    /**
     * Main nav click Event handler
     */
    var adjustMainNavBarMaxHeightHandler = function(){
        if($(window).width() < 768){
            // get window height
            var wh = common.getWindowHeight();
            // get header height
            var hh = common.getNavHeight();
            // adjust main nav
            adjustMainNavBarMaxHeight(wh, hh);
        }
    };

    /**
     * _minDiff setter
     */
    var setMinDiff = function(minDiff){
        _minDiff = minDiff;
    };

    /**
     * _minDiff getter
     */
    var getMinDiff = function(){
        return _minDiff;
    };

    /**
     * _currentScrollTop setter
     */
    var setCurrentScrollTop = function(currentScrollTop){
        _currentScrollTop = currentScrollTop;
    };

    /**
     * _currentScrollTop getter
     */
    var getCurrentScrollTop = function(){
        return _currentScrollTop;
    };

    /**
     * Detect Scrolling direction
     */
    var detectScrollingDirection = function(newScrollTop, minDiff, currentScrollTop){
        var dir = 0;
        if(newScrollTop > currentScrollTop){
            // scroll down
            dir = 1;
        }else if(newScrollTop < currentScrollTop){
            dir = -1;
        }
        // check whether user scroll way back to the max top or not
        if(newScrollTop == 0){
            dir = -1; // show main nav
        }
        // check whether user scroll pass minimum height or not
        if(newScrollTop < minDiff){
            dir = -1; // show main nav
        }
        // update current scroll top
        setCurrentScrollTop(newScrollTop);

        return dir;
    }

    /**
     * _dirQueue setter
     */
    var setDirQueue = function(dirQueue){
        _dirQueue = dirQueue;
    }

    /**
     * _dirQueue getter
     */
    var getDirQueue = function(){
        return _dirQueue;
    }

    /**
     * Adjust Main nav position
     */
    var adjustMainNavPosition = function(dir, dirQueue){
        var move_dir = 0;

        // update queue
        // if queue if full, we remove the oldest queue
        if(dirQueue.length >= _maxDirQueueLength){
            dirQueue = _.drop(dirQueue);
        }
        // we a new dir to queue
        dirQueue.push(dir);

        if(dirQueue.length == _maxDirQueueLength){
            // iterate to see all of the queue is in the same direction
            var sumdir = _.reduce(dirQueue, function(sum, n){
                return sum + n;
            });
            // check if sum of current direction is equal to sum of move up/down direction
            if(sumdir == _maxDirQueueLength * -1){
                move_dir = -1;
            }else if(sumdir == _maxDirQueueLength){
                move_dir = 1;
            }
        }

        if(move_dir < 0){
            // scroll up, we show main nav
            $('#main-nav').removeClass('move_up');
            $('#header-nav').removeClass('hide-main-nav');
        }else if(move_dir > 0){
            // check if a user is open nav or not
            if(!$('#main-navbar').hasClass('in')){
                // scroll down, we hide main nav
                $('#main-nav').addClass('move_up');
                $('#header-nav').addClass('hide-main-nav');
            }
        }
        // otherwise, do nothing

        // update stored _dirQueue
        setDirQueue(dirQueue);
    }

    /**
     * Scrolling Event handler
     */
    var detectScrollingDirectionHandler = function(){
        // detect scrolling direction
        var newScrollTop = common.getWindowScrollTop();
        var currentScrollTop = getCurrentScrollTop();
        var minDiff = getMinDiff();
        var dir = detectScrollingDirection(newScrollTop, minDiff, currentScrollTop);
        var dirQueue = getDirQueue();
        adjustMainNavPosition(dir, dirQueue);
    };

    /**
     * Show search bar
     */
    var showSearchBar = function(){
        $('#open-search-btn').addClass('active');
        $('#search-bar-holder').addClass('active');
    };

    /**
     * Hide search bar
     */
    var hideSearchBar = function(){
        $('#open-search-btn').removeClass('active');
        $('#search-bar-holder').removeClass('active');
        clearSearchResult();
    };

    /**
     * Clear search input
     */
    var clearSearchResult = function(){
        $('#search-input').val('');
    };

    /**
     * Search button click handler
     */
    var showSearchBarHandler = function(e){
        showSearchBar();
    };
    var hideSearchBarHandler = function(e){
        hideSearchBar();
    };

    /**
     * Toggle other menu
     */
    var toggleOtherMenu = function(){
        if($('#other-btn').hasClass('active')){
            $('#other-btn').removeClass('active');
        }else{
            $('#other-btn').addClass('active');
        }
        if($('#other-menu-holder').hasClass('active')){
            $('#other-menu-holder').removeClass('active');
        }else{
            $('#other-menu-holder').addClass('active');
        }
        if($('#main-navbar').hasClass('show-other-menu')){
            $('#main-navbar').removeClass('show-other-menu');
        }else{
            $('#main-navbar').addClass('show-other-menu');
        }
    };

    /**
     * Other menu click handler
     */
    var toggleOtherMenuHandler = function(e){
        toggleOtherMenu();
    };

    /**
     * Init Header
     */
    var headerInit = function(){
        $(document)
            //.on('show.bs.collapse', '#navbar', adjustNavBarMaxHeightHandler)
            //.on('show.bs.collapse', '#main-navbar', adjustMainNavBarMaxHeightHandler)
            .on('click', '#open-search-btn', showSearchBarHandler) // show search bar
            .on('click', '#close-search-bar', hideSearchBarHandler) // hide search bar
            .on('click', '#other-btn', toggleOtherMenuHandler) // show/hide other menu
            .on('click', '.search-tablet-holder a', showSearchBarHandler) // show search bar for tablet

        //adjustMainNavBarMaxHeightHandler();

        setCurrentScrollTop(common.getWindowScrollTop());
        /*$(window)
            //.on('scroll', detectScrollingDirectionHandler)
            .on('resize', adjustNavBarMaxHeightHandler)
            .on('resize', adjustMainNavBarMaxHeightHandler);*/
    };

    return {
        init: headerInit,
        adjustNavBarMaxHeight: adjustNavBarMaxHeight,
        adjustMainNavBarMaxHeight: adjustMainNavBarMaxHeight,
        detectScrollingDirection: detectScrollingDirection,
        adjustMainNavPosition: adjustMainNavPosition,
        showSearchBar: showSearchBar,
        hideSearchBar: hideSearchBar,
        clearSearchResult: clearSearchResult,
        toggleOtherMenu: toggleOtherMenu,
        getMinDiff: getMinDiff,
        setMinDiff: setMinDiff,
        getCurrentScrollTop: getCurrentScrollTop,
        setCurrentScrollTop: setCurrentScrollTop,
        setDirQueue: setDirQueue,
        getDirQueue: getDirQueue,
        getNavMaxHeight: getNavMaxHeight,
        getMaxDirQueueLength: getMaxDirQueueLength
    };
})();

module.exports = TPBS_header;